import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MenteeGroupData } from '../../providers/mentee-group-data'
import { UserData } from '../../providers/user-data'
import { GlobalVariable } from '../../global'
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ToastController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the AddMenteeToMenteeGroupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-add-mentee-to-mentee-group',
  templateUrl: 'add-mentee-to-mentee-group.html',
})
export class AddMenteeToMenteeGroupPage {

  menteegroups: any
  mentees: any
  addusertogroupForm: FormGroup
  duplicateErrorArray: any
  usertype: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private menteeGroupData: MenteeGroupData, private userData: UserData,
    private formBuilder: FormBuilder, private toastCtrl: ToastController, private alertCtrl: AlertController, private storage: Storage) {
    this.storage.get('usertype').then((value) => {
      this.usertype = value;
      if (this.usertype != GlobalVariable.Admin) {
        this.navCtrl.setRoot(HomePage);
      }
    });
    this.addusertogroupForm = this.formBuilder.group({
      groupid: ['', Validators.required],
      users: ['', Validators.required]
    });
  }


  ionViewDidLoad() {
    this.getMenteeGroup()
    this.getUserList()
  }


  getMenteeGroup() {
    this.menteeGroupData.getMenteeGroup().subscribe(
      res => {
        this.menteegroups = res['data']
      },
      err => {
        this.presentAlert('Error', 'Something went wrong, try again')
      }
    )
  }

  getUserList() {
    this.menteeGroupData.getMenteeByAdmin().subscribe(
      res => {
        this.mentees = res['data']
        this.mentees.map(item => {
          item.usertype = GlobalVariable.Mentee
        })
      }
    )
  }

  onSubmit(value) {
    this.duplicateErrorArray = []
    this.menteeGroupData.addMenteeToMenteeGroup(value).subscribe(
      res => {
        if (res['success']) {
          this.presentToast(res['message'])
          this.addusertogroupForm.reset()
        }
      },
      err => {
        if (err.error.data.length > 0) {
          this.duplicateErrorArray = err.error.data
        }
      }
    )
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/add-mentee-to-mentee-group/add-mentee-to-mentee-group.ts